import React from 'react'
import { getImages } from '../Components/Common/const'
import HomeReviews from '../Components/Home/HomeReviews'
import SeoMeta from '../Components/Common/SeoMeta'
import { Helmet } from 'react-helmet'

const AboutUs = () => {
    return (
        <>
            <Helmet>
                <title>About Mercedes Showroom | Family-Owned Mercedes Dealer</title>
                <meta name="description" content="Learn about our history and dedication to quality. Serving Pompano Beach with premium used Mercedes-Benz since 1987." />
                <meta name="keywords" content="" />
                <meta property="og:title" content="About Mercedes Showroom | Family-Owned Mercedes Dealer" />
                <meta property="og:description" content="Learn about our history and dedication to quality. Serving Pompano Beach with premium used Mercedes-Benz since 1987." />
            </Helmet>
            <section className='common-wrap d-flex align-items-center' style={{ backgroundImage: `url(${getImages('about-hero-bg.webp')})` }}>
                <div className='w-100'>
                    <div className='container'>
                        <h1 className='xl-title text-uppercase text-center wow reveal fadeInUp'>About Us</h1>
                        <h2 className='lg-title text-uppercase text-center fw-500 mt-3 mb-3 wow reveal fadeInUp'>Established in 1987</h2>
                    </div>
                </div>
            </section>
            <section className='about-video-wrap wow reveal fadeIn'>
                <div className='container'>
                    <div className='iframe-container'>
                        <iframe width="100%" height="650" src="https://www.youtube.com/embed/1aVExWpcn3E?si=FxkW6xxX-xG_rDg3" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>
                </div>
            </section>
            <section className='drive-home-wrap d-lg-flex align-items-center about-drive-wrap'>
                <div className='w-50'>
                    <div className='mxw-580 mx-auto px-xl-0 px-4'>
                        <h3 className='lg-title text-uppercase mb-3'>A FAMILY BUSINESS SINCE 1987</h3>
                        <div className="common-text">
                            <p>Mercedeshowroom, now owned by Bobby and Kendall Berk, is a second generation family-owned business specializing in pre-owned Mercedes.  Started back in 1987 by Bobby’s parents, Steve and Meta Berk, Bobby learned first hand how important customer satisfaction is.  Buying, repairing, detailing, and selling, though critical  aspects of the automobile business, mean nothing without maintaining an honest relationship with the customer before, during, and after the sale.  This is where we excel, and why we are still in business 38 years later.</p>
                        </div>
                    </div>
                </div>
                <div className='w-50'>
                    <img className="w-100" src={getImages('a-family-business.jpg')} />
                </div>
            </section>
            <section className='key-service-wrap about-key-wrap'>
                <div className='container'>
                    <div className='mxw-1080 mx-auto wow reveal fadeInUp'>
                        <h4 className='lg-title text-uppercase mb-3'>Why would you buy your next Mercedes from Mercedeshowroom?</h4>
                        <div className='common-text'>
                            <p>Because we have a large inventory of very clean, low mileage, pre-owned Mercedes including sedans, coupes, convertibles, diesels, wagons and SUV’s.  Our owners and management have over 35 years experience in the industry and they understand your requirements for purchasing this unique automobile.  Because we specialize in Mercedes automobiles, we know what to look for when we buy cars, just as you know what you are looking for.  Service, financing, and fine detailing are available in our indoor showroom located in Pompano Beach, Florida. We can ship your purchase anywhere in the world, and of course trade ins are always welcome.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='about-review-wrap pb-5'>
                <HomeReviews />
            </section>
        </>
    )
}

export default AboutUs